import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loading } from "components/Loading/loading";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Toast } from "components/ToastShow/ToastAlert";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { useContext, useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { InputTypes, MessageType } from "types/enum";
import { GUID_EMPTY, ICON_TYPE } from "utils/constants";
import { trans } from "utils/helpers";
import {
  CheckExist,
  checkForm,
  getDataForPrint,
  getDataGridAvailable,
  getDictionaryAvailable,
  getDynamicDataGridApi,
  getFormByKey,
  postForm,
  putForm,
  ExportForm
} from "./api";
import { CreateInputForm } from "./components/CreateForm";
import { postGridForm } from "./components/DataGridForm/api";
import { DynamicFormDataEntry } from "./components/DynamicFormDataEntry/DynamicFormDataEntry";
import {
  DictionaryAvailable
} from "./components/InputAvailable";
import { InputDetector } from "./components/InputDetector";
import { InputSetting } from "./components/InputSetting/InputSetting";
import { ListToolBar } from "./components/ListToolBar";
import "./style.scss";
import { transformDataStructure } from "./hooks/helpers";

 

const defaultForm =   {
        "DataType": "",
        "Label": "",
        "OldSystemKey": "",
        "DefaultValue": null,
        "MinValue": null,
        "MaxValue": null,
        "WithTime": null,
        "MaxLength": null,
        "MinLength": null,
        "Options": null,
        "SystemKey": "",
        "Step": null,
        "Required": false,
        "IsIdentity": false,
        "Condition": null,
        "Formula": null,
   
    }

export const FormBuilder = ({createGrid=false,gridPageMode=null,designMode=false,selectedObj,reload,acceptRestroeData=false,setAcceptRestroeData}) => {
  const [showCreateForm, setShowCreateForm] = useState<boolean>(false);
  const [defaultSettingObj, setDefaultSettingObj] = useState<any>({});
  const [toolBarType, setToolBarType] = useState<any>(createGrid ?1 :0);
  const [dragItem, setDragItem] = useState<any>(null);
  const [inputs, setInputs] = useState<any>([]);
  const [formula, setFormula] = useState<any>({});
  const [condition, setCondition] = useState<any>({});


  const [positionOnPage, setPositionOnPage] = useState<any>([]);
  const [selectInputForm, setSelectInputForm] = useState<boolean>(false);
  const [showSetting, setShowSetting] = useState<boolean>(false);
  const [editInput, setEditInput] = useState<any>();
  const [indexEditInput, setIndexEditInput] = useState<any>();
  const [informationForm, setInformationForm] = useState<any>(null);
  const [forms, setForms] = useState<any>();
  const [editInputStatus, setEditInputStatus] = useState<boolean>(false);
  const [colSelectMove, setColSelectMove] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingAfterSetting, setLoadingAfterSetting] = useState<boolean>(true);
  const [formsLoading, setFormLoading] = useState<boolean>(true);
  const [forceUpdate, setForceUpdate] = useState<boolean>(false);
  const [buttonPrintObj,setButtonPrintObj]=useState<any>(null)
  const [showFormInViewMode, setShowFormInViewMode] = useState<boolean>(false);
  const [FormInViewMode, setFormInViewMode] = useState<any>();
  const [preview, setPreview] = useState<boolean>(false);
  const [changed,setChanged]=useState(false)
  const [inputMode, setInputMode] = useState<"create" | "edit" | "duplicate">(
    "create"
  );
  const [formMode, setFormMode] = useState<"create" | "edit" | "view">(gridPageMode?gridPageMode:"view");
  const [countList, setCountList] = useState<any>({
    text: 0,
    textArea: 0,
    number: 0,
    date: 0,
    time: 0,
    timeLength: 0,
    selectBox: 0,
    RadioButton: 0,
    checkBox: 0,
    ProgressBar: 0,
    price: 0,
    Message: 0,
    Step: 0,
    Position: 0,
    Person: 0,
    Sex: 0,
  });
  const [objectStep, setObjectStep] = useState<any>({});
  const [userChanges, setUserChanges] = useState<boolean>(false);
  const [stateBoxInput, setStateBoxInput] = useState<
    "edit" | "delete" | "clone" | null
  >(null);
  const [showResetBtn, setShowResetBtn] = useState<boolean>(false);
  const [selectingItemForDelete, setSelectingItemForDelete] =useState<any>(null);
  const [deleteTimerMode, setDeleteTimerMode] = useState<boolean>(false);
  const [dynamicFormApplications, setDynamicFormApplications] = useState<any>([]);
  const [isWorkflowEnable, setIsWorkflowEnable] = useState<any>();
  const spaceIndexRef = useRef<any>(null);
  const deleteTimer = useRef<any>();




  const [dataDictionary, setDataDictionary] = useState<any>([]);
  const [resetForm,setResetForm]=useState(false)

  let checkClickHold = false;
  let checkTimeHold = false;
  let flag = true;

  const Requester = {
    label: "درخواست کننده",
    SystemKey: "RequesterPositionId",
    backendType: "guid",
    disable: true,
    typeName: "PositionDictionary",
    defaultValue: GUID_EMPTY,
    required: true,
    size: "4",
  };
 const ActivityStatus = {
    label: "وضعیت",
    SystemKey: "activityStatus",
    backendType: "string",
    disable: true,
    typeName: "activityStatus",
    defaultValue: '1',
    required: false,
    size: "4",
  };
  const defaultDescription = {
    typeName: "textArea",
    backendType: "string",
    label: "شرح",
    size: "12",
    InputType: "1",
    SystemKey: "Description",
    defaultValue: "",
    required: true,
    disable: false,
    maxLength: "",
    placeholder: "",
  };

  let layoutContext = useContext(LayoutContext);
  const formBx = useRef<any>();
  const selectInput = (e, event: any = null) => {
    if (event) {
      setPositionOnPage([event.pageX, event.pageY]);
    }
    setDragItem(e);
  };

  const moveDragInput = (e) => {
    e.stopPropagation();
    setPositionOnPage([e.pageX, e.pageY]);
  };

  const showspace = (Obj, id ,cardIndex =0) => {
    if (dragItem != null) {
      if (document.getElementById("ViewBox") == null) {
          if(Obj=="Obj"){
          
              document
                .getElementById("cardId"+cardIndex)
                ?.insertAdjacentHTML(
                  "beforeend",
                  `<div id="ViewBox" class="col-${
                    colSelectMove ? colSelectMove : "6"
                  } formBoxDr"><div class="formBuilder__formBx__viewBox color_highlightPrimary" style="height:100px; border:2px dashed green;"></div></div>`
                );
          }else{
          
            if (spaceIndexRef == id) {
              document
                .getElementById(id)
                ?.insertAdjacentHTML(
                  "afterend",
                  `<div id="ViewBox" class="col-${
                    colSelectMove ? colSelectMove : "6"
                  } formBoxDr"><div class="formBuilder__formBx__viewBox color_highlightPrimary" style="height:100px; border:2px dashed green;"></div></div>`
                );
              spaceIndexRef.current = null;
            } else {
              document
                .getElementById(id)
                ?.insertAdjacentHTML(
                  "beforebegin",
                  `<div id="ViewBox" class="col-${
                    colSelectMove ? colSelectMove : "6"
                  } formBoxDr"><div class="formBuilder__formBx__viewBox color_highlightPrimary" style="height:100px; border:2px dashed green;"></div></div>`
                );
              spaceIndexRef.current = id;
            } 
          }
      }
    }
    document.getElementById("ViewBox")?.addEventListener("mouseleave", () => {
      document.getElementById("ViewBox")?.remove();
    });
    document.getElementById("ViewBox")?.addEventListener("mouseup", (event) => {
      addNewInput(dragItem, +id.replace(cardIndex+"inputsId", "") ,cardIndex );
      document.getElementById("ViewBox")?.remove();
    });
  };

  const DropInput = (e) => {
    if (e.target && e.target?.className?.includes("formBuilder__formBx")) {
      document.removeEventListener("mouseup", DropInput);
    } else {
      if (indexEditInput) {
        let newInput = [...inputs];
        newInput[indexEditInput.cardIndex].inputList.splice(indexEditInput.index, 0, e);
        setInputs(newInput);
      }
    }
    setDragItem(null);
    setIndexEditInput(null);
  };
  const closeSetting = () => {
    if (inputMode != "edit") {
      if (indexEditInput.index != -1) {
        // inputs.splice(indexEditInput,1)
      }else {
        inputs.pop();
      }
    }
    setIndexEditInput(null);
    setShowSetting(false);
  };

  const CheckStepper = (state, indexInList, stepInfo? ,label?,count=1) => {
    let newInputs =[ ...inputs] ;
    const fristStep = {
      type: dragItem?.type,
      typeName: dragItem?.typeName,
      inputList: [],
      stepNumber:1,
      backendType: dragItem?.backendType,
      size: 12,
      label:label ?label: dragItem?.label,
      isOpen: true,
      // SystemKey: dragItem?.typeName+ 1,
           SystemKey: (dragItem?.backendType !='guid') ?dragItem?.typeName + count:
      (dragItem?.typeName + count)+'Id'  
    };
    if (state == "create") {
      if (inputs[0].typeName != "Step"||true) {
        if (indexInList != -1) { 
          newInputs.splice(indexInList, 0, {
            ...fristStep,
            SystemKey: dragItem.typeName + count,
          });

          setCountList({ ...countList, Card: 2 });
          //// setCountList({ ...countList, Step: 2 });
        } else {
          newInputs = [fristStep, ...newInputs];
          setCountList({ ...countList, Card: 1 });
          //// setCountList({ ...countList, Step: 1 });
        }
      } else {
        newInputs.splice(indexInList, 0, {
          ...fristStep,
          SystemKey: dragItem.typeName + (+countList.Step + 1),
        });
        setCountList({ ...countList, Step: +countList.Step + 1 });
      }
    } else if (state == "move") {
      newInputs.splice(indexInList, 0, { ...fristStep, stepInfo });
    } else { 
      if (indexInList == 0 && countList.Card > 1) {
      ////if (indexInList == 0 && countList.Step > 1) {
      } else {
        newInputs.splice(indexInList, 1);
      }
    }
    setInputs(newInputs);
  };



  
  const addNewInput = (e, inpo ,cardIndex=-1) => { 

    


    let newInputs = [...inputs];
    let InputFlatList = newInputs.flatMap(item => item.inputList);
    const restrictedTypes = ['SystemNumber', 'attachment', 'activityStatus'];
    if(restrictedTypes.includes(e.typeName) &&
    InputFlatList.some(item => item.typeName === e.typeName) ){
      return null
    }
    const filterItem= [...InputFlatList,...newInputs].filter(item=>((item.typeNameEn && dragItem.typeNameEn)?  item.typeNameEn==dragItem.typeNameEn: item.typeName==dragItem.typeName))
    let count=filterItem?.length

const findItem=filterItem?.some(item=>item?.SystemKey==(item?.typeNameEn && dragItem.typeNameEn?  item?.typeNameEn: item?.typeName)+count)
if(findItem){
  count+=1
}
    let countLetList = { ...countList };
    
    if (dragItem != null) {
      if (countLetList[dragItem.typeName] == undefined)
        countLetList[dragItem.typeName] = 0;
      if (indexEditInput == null) {
      
        
        setInputMode("create");
        setShowSetting(false);
        const newInput = {
          ...dragItem,
          type: dragItem.type,
          typeName: dragItem.typeName,
          initialSystemKey:dragItem.SystemKey?dragItem.SystemKey:dragItem.typeName,
          backendType: dragItem.backendType,
          label: dragItem.typeName + (count>0?count:'') ,
          size: defaultSettingObj?.size ? defaultSettingObj?.size : 12,
          icon: dragItem.icon,
          isOpen: true,
          InputType:
            dragItem.typeName == "textArea"
              ? "1"
              : dragItem.typeName == "number" || dragItem.typeName == "decimalNumber"
              ? "6"
              : "0",
          Keywords: [],
          ...(dragItem.typeName == "RadioButton" && {
            Keywords: [{name: "بله" ,SystemKey:"yes" } , {name:"خیر" ,SystemKey:"no" }],
          }),
          ...dragItem,
          SystemKey: dragItem.SystemKey ? 
            (dragItem.type==InputTypes.dataGrid||dragItem.type==InputTypes.DynamicDictionary)  ?
               (  count>0?dragItem.SystemKey + (count ) : dragItem.SystemKey):
               dragItem.backendType=="guid" ?
                  (count>0  ?dragItem.SystemKey + (count )+'Id': dragItem.SystemKey+"Id") :
                   dragItem.typeName + (count>0?count:'' ):
            dragItem.typeName + (count>0?count:'' )
        };
      
        if (dragItem.typeName == "Card") {
        //// if (dragItem.typeName == "Step") {

          CheckStepper("create", cardIndex , null ,trans(dragItem.typeName) + (count>0?count:''),count  );
        } else {
          setCountList({
            ...countLetList,
            [dragItem.typeName]:countLetList[dragItem.typeName] + 1,
          });
          if (inpo == -1) {

 
            newInputs[cardIndex].inputList.push(newInput);
          } else {
            newInputs[cardIndex].inputList.splice(inpo, 0, newInput);
          }     
            setInputs(newInputs);
        }
      } else {
        if (e.typeName == "Card") {
        ////if (e.typeName == "Step") {
          CheckStepper("move", inpo, e);
        } else {
          let newInputs = [...inputs];
          if (inpo !== null) {
            if (inpo == -1) {
              newInputs[cardIndex].inputList.splice(inputs[cardIndex].inputList.length, 0, { ...dragItem, ...e });
            } else {
              newInputs[cardIndex].inputList.splice(inpo, 0, { ...dragItem, ...e });
            }
          } else {
          }
          setInputs(newInputs);
          setIndexEditInput(null);
        }
      }
    } else {
      let item = inputs[cardIndex].inputList[inpo];
      if (countLetList[item.typeName] == undefined)
        countLetList[item.typeName] = 0;

      const newInput = {
        label: item?.typeName + count>0?count:'',
        type: +item?.type,
        typeName: item?.typeName,
        backendType: item?.backendType,
        size: item?.size,
        InputType: +item?.InputType,
        Keywords: item?.Keywords,
        icon: item.icon,
        // SystemKey:
        // inputs[inpo]?.typeName + count>0?count:'',
        SystemKey: item?.backendType!='guid'? item?.typeName + count>0?count:'':(item?.typeName + count>0?count:'')+'Id',
      };
      setCountList({
        ...countLetList,
        [item.typeName]: countLetList[item.typeName] + 1,
      });

      if (inpo == -1) {
        newInputs[cardIndex].inputList.push(newInput);
      } else {
        newInputs[cardIndex].inputList.splice(inpo, 0, newInput);
      }
      setIndexEditInput(null);
      setInputs(newInputs);
      setDragItem(null);
    }
    setUserChanges(true);
  };

  const removeInput = (
    e,
    inputsIndex,
    cancel: "delete" | "confirmDelete" | "cancelDelete"|"deleteCard" | "confirmDeleteCard",
    cardIndex
  ) => {
    if (cancel == "delete") {
      setDeleteTimerMode(true);
      setSelectingItemForDelete({index:inputsIndex , cardIndex});
      setShowResetBtn(true);
      deleteTimer.current = setTimeout(() => {
        if (
          inputs[cardIndex].inputList[inputsIndex]?.SystemKey != "Description" &&
          inputs[cardIndex].inputList[inputsIndex]?.SystemKey != "RequesterPositionId"
        ) {
          if (inputs[cardIndex].inputList[inputsIndex].typeName == "Card") {
         //// if (inputs[cardIndex].inputList[inputsIndex].typeName == "Step") {
            CheckStepper("remove", inputsIndex);
          } else {
            e.stopPropagation();
            let newInputs = [...inputs];
            newInputs[cardIndex].inputList.splice(inputsIndex, 1);
            setInputs(newInputs);
          }
        }
        setDeleteTimerMode(false);
        setUserChanges(true);
        setShowResetBtn(false);
      }, 4500);
    } else if (cancel == "confirmDelete") {
      clearTimeout(deleteTimer.current)
      if (
        inputs[cardIndex].inputList[inputsIndex].SystemKey != "Description" &&
        inputs[cardIndex].inputList[inputsIndex].SystemKey != "RequesterPositionId"
      ) {
        if (inputs[cardIndex].inputList[inputsIndex].typeName == "Card") {
        ////if (inputs[cardIndex].inputList[inputsIndex].typeName == "Step") {
          CheckStepper("remove", inputsIndex);
        } else {
          e.stopPropagation();
          let newInputs = [...inputs];
          newInputs[cardIndex].inputList.splice(inputsIndex, 1);
          setInputs(newInputs);
        }
        setDeleteTimerMode(false);
      }
      setUserChanges(true);
      setShowResetBtn(false);
    } else if (cancel == "cancelDelete") {
      setDeleteTimerMode(false);
      setSelectingItemForDelete(null);
      clearTimeout(deleteTimer.current);
      setShowResetBtn(false);
    }else if(cancel=="deleteCard"){
       setDeleteTimerMode(true);
       setSelectingItemForDelete({index:-1 , cardIndex :inputsIndex });
      setShowResetBtn(true);
      deleteTimer.current = setTimeout(() => {
        e.stopPropagation();
        let newInputs = [...inputs];
        newInputs.splice(inputsIndex, 1);
        setInputs(newInputs);
        setDeleteTimerMode(false);
        setUserChanges(true);
        setShowResetBtn(false);
      }, 4500);
    }
     else if (cancel == "confirmDeleteCard") {
      clearTimeout(deleteTimer.current)
       setDeleteTimerMode(true);
       setSelectingItemForDelete({index:-1 , cardIndex :inputsIndex });
        e.stopPropagation();
        let newInputs = [...inputs];
        newInputs.splice(inputsIndex, 1);
        setInputs(newInputs);
        setDeleteTimerMode(false);
        setUserChanges(true);
        setShowResetBtn(false)
    }
  };

  const settingChange = (e ) => {
    let newInputs = [...inputs];
    if (indexEditInput.index == -1) {
      if(indexEditInput.cardIndex ||indexEditInput.cardIndex==0 ){
        newInputs.splice(indexEditInput.cardIndex, 1, { ...editInput, ...e });
          
      }else{
        newInputs.pop();
        newInputs.push({ ...editInput, ...e });
      }
    } else {
      // drag and dublecate
      if (editInputStatus) {
        newInputs[indexEditInput.cardIndex].inputList.splice(indexEditInput.index + 1, 1, { ...editInput, ...e });
      } else {
        if (inputMode == "duplicate") {
          newInputs[indexEditInput.cardIndex].inputList.splice(indexEditInput.index + 2, 0, { ...editInput, ...e });
          newInputs[indexEditInput.cardIndex].inputList.splice(indexEditInput.index, 1);
        } else {
          newInputs[indexEditInput.cardIndex].inputList.splice(indexEditInput.index, 0, { ...editInput, ...e });
          newInputs[indexEditInput.cardIndex].inputList.splice(indexEditInput.index + 1, 1);
        }
      }
    }
    setLoadingAfterSetting(false);    
    setInputs(newInputs);
    setEditInputStatus(false);
    setDragItem(null);
    setUserChanges(true);
  };




  async function getFormByNameAsync(formKey, mode? , endfunc?) {
    setLoading(false);
    try {
      if (formMode != "view" && mode != "copy") {
        setShowFormInViewMode(true);
        setFormInViewMode(formKey);
      } else {
        const respons = await getFormByKey(formKey,null,null,false,true);
        if (mode == "copy") {
          navigator.clipboard.writeText(JSON.stringify(JSON.parse( respons.Data?.DynamicForms.FormFields)) );
          // Toast(trans("copy"), "success");
          Toast(trans("copy"), MessageType.success);
        } else {
let newData:any =null
          if(! JSON.parse( respons.Data?.DynamicForms.FormFields)?.inputList[0].inputList){
           newData =   transformDataStructure(JSON.parse( respons.Data?.DynamicForms.FormFields))
      
          }

          updateCountForEditMode(
            (newData??JSON.parse( respons.Data?.DynamicForms.FormFields))?.inputList
          );
          setInputs((newData??JSON.parse( respons.Data?.DynamicForms.FormFields))?.inputList);
          setCondition((newData??JSON.parse( respons.Data?.DynamicForms.FormFields))?.condition);
    

          setFormula((newData??JSON.parse( respons.Data?.DynamicForms.FormFields))?.formula)
       //   setInputs(JSON.parse( respons.Data?.DynamicForms.FormFields)?.inputList);
          setInformationForm({
            formTitle: respons.Data?.DynamicForms.FormTitle,
            SystemKey: respons.Data?.DynamicForms.FormKey,
            IsWorkflowEnable: respons.Data?.DynamicForms.IsWorkflowEnable,
            FormTitleEN: respons.Data?.DynamicForms.FormTitleEN,
            HasSignature: respons.Data?.DynamicForms.HasSignature,
            FormPriority: respons.Data?.DynamicForms.FormPriority,
            DynamicFormApplications: respons.Data?.DynamicFormApplications,
            Id: respons.Data?.DynamicForms.Id
              ? respons.Data?.DynamicForms.Id
              : null,
          });

                if (respons.Data?.DynamicForms?.Id &&
               respons.Data?.DynamicForms?.Id  != GUID_EMPTY) {    
       setButtonPrintObj({
           Id: respons.Data?.DynamicForms?.Id,
                                reportDomain:"DynamicForm",
                                objectTag:formKey,
                                apiFunction:getDataForPrint,
                                params:{formKey:formKey},
          });
      }
        }
      }
    } catch (err: any) {}
    endfunc && endfunc()
    setLoading(true);
  }




async function getFormByNameDownloadAsync(formId) {
;
   
        const respons =   await ExportForm(formId)
        const contentDisposition = respons.headers['file-name'];   
        let fileName = 'downloaded-file'; // Default filename
        if (contentDisposition) {
                fileName = contentDisposition.split('.')[0]
            }
            var pom = document.createElement('a');
            pom.setAttribute('href', window.URL.createObjectURL(respons.data));
            pom.setAttribute('download', fileName);
            pom.click();
            try {
        } catch (error) {
            
        }
    
  }





  const updateCountForEditMode = (inputs) => {
    let newCountList = countList;
    inputs.map((input) => {
      if (
        input.SystemKey != "Description" &&
        input.SystemKey != "RequesterPositionId"
      ) {
        newCountList = {
          ...newCountList,
          [input.typeName]: +newCountList[input.typeName] + 1,
        };
      }
    });
    setCountList(newCountList);
  };




  const sendData = async (e,data={} as any,closeInputsForm=true,changedInput=inputs) => {
    
    //to use data when formdata is edit and just open createinputform component ,we enter this fun by CheckExistAsync fun  . we dont have informationForm so we use data rather than informationForm.
    e.preventDefault();


    let inputList = changedInput;
    let FormObject: any = {};
    let FormObject2: any = [];
    let stepIndex = 0;
    let isStepUnvalued = false;
    let kyW: any = [];
    let DynamicFormDataGrids: any = {};
    let objectLabels: any = [];
    const isWorkflowEnableVar=informationForm?.DynamicForms?.IsWorkflowEnable || informationForm?.IsWorkflowEnable
    const isWorkflowEnableVarData=data?.DynamicForms?.IsWorkflowEnable || data?.IsWorkflowEnable
      inputList.map((step,index) => {
       if(inputList[index].type==14){

         inputList[index].SystemKey=inputList[index].SystemKey.replaceAll('Step','Card')
         inputList[index].type=18
         inputList[index].typeName=inputList[index].typeName.replaceAll('Step','Card')
       }

step?.inputList.map((item,index)=>{
      if (item.typeName == "Step"||item.typeName == "Card") {
        stepIndex += 1;

        if (inputList[index + 1].typeName == "Card") {
    //// if (inputList[index + 1].typeName == "Step") {
          isStepUnvalued = true;
        }
        if (stepIndex != 0) {
          if (
            inputList[0].typeName &&
            inputList[0].typeName != "Card" &&
           //// inputList[0].typeName != "Step" &&
            inputList[inputList.length - 1].typeName == "Card"
           //// inputList[inputList.length - 1].typeName == "Step"
          ) {
            isStepUnvalued = true;
          }
        }
      }



      if (item.type == InputTypes.dataGrid) {   
        DynamicFormDataGrids[item.SystemKey] = item?.initialSystemKey?item?.initialSystemKey:item.SystemKey.replace(/\d{1,2}$/, '')
     //   objectLabels = { ...objectLabels, [item.SystemKey]: item.label };
      }
      if (item.typeName == "RadioButton" || item.typeName == "selectBox") {
        kyW.push({
          [item.SystemKey]:item.Keywords.map(item=>item.SystemKey),
        });
        objectLabels = { ...objectLabels, [item.SystemKey]: item.label };
      }

      if (item.typeName == "Position" || item.typeName == "Person"|| item.backendType == "guid" || ( item.typeName=="url" && item?.inputType=="AutoCompleteDictionary")) {//اضافه کردن فیلد دسکریشن برای ایتم هایی که باید بهشون توضیحات اضافه کنیم
       FormObject[item.SystemKey + "Description"] = "string";
      if(item?.SystemKey!="Description" && item?.SystemKey!="RequesterPositionId" &&  item?.SystemKey!="RequesterPositionIdDescription"){// اگر ایزورک فلو فعال باشد نباید اینپوت های دسکریپشن و رکوئستر بفرستیم    
        FormObject2.push({
           ...defaultForm,
         "DataType": "string",
         "Label": item.label?item.label :item.SystemKey ,
         "MinValue": item.min,
         "MaxValue": item.max,
         "DefaultValue":null,
         "WithTime":item.WithTime ?  item.WithTime== "withTime" :null,
         "MaxLength": +item.maxLength==0 ?null :+item.maxLength,
         "MinLength": +item.minLength,
         "Options": (item.typeName === 'selectBox' || item.typeName === 'RadioButton') ?  item.keyWords : null,
         "SystemKey": item.SystemKey + "Description",
         "OldSystemKey": item.SystemKey + "Description",
         "Step": stepIndex,
         "Required": item.required,
         "IsIdentity": item.SystemKey === "SystemNumber" ? true : false,
         "Condition": item.Condition ?? null,
         "Formula": item.Formula ?? null,

     }) 
      }   
      }  
      if (item.type == InputTypes.DynamicDictionary) {
        FormObject[item.SystemKey + "Description"] = "string";
              if( item?.SystemKey!="Description" && item?.SystemKey!="RequesterPositionId" &&  item?.SystemKey!="RequesterPositionIdDescription"){// اگر ایزورک فلو فعال باشد نباید اینپوت های دسکریپشن و رکوئستر بفرستیم

        FormObject2.push({
           ...defaultForm,
         "DataType": "string",
         "Label": item.label?item.label :item.SystemKey ,
         "MinValue": item.min,
         "MaxValue": item.max,
         "DefaultValue":item.defaultValue? item.defaultValue:null,
         "WithTime":item.WithTime ?  item.WithTime== "withTime" :null,
         "MaxLength": +item.maxLength==0 ?null :+item.maxLength,
         "MinLength": +item.minLength,
         "Options": (item.typeName === 'selectBox' || item.typeName === 'RadioButton') ?  item.keyWords : null,
         "SystemKey": item.SystemKey + "Description",
         "OldSystemKey": item.SystemKey + "Description",
         "Step": stepIndex,
         "Required": item.required,
         "IsIdentity": item.SystemKey === "SystemNumber" ? true : false,
         "Condition": item.Condition ?? null,
         "Formula": item.Formula ?? null,



     }) }
      }
      item.StepIndex = stepIndex;
      if (item.backendType != "") {
        objectLabels = { ...objectLabels, [item.SystemKey]: item.label };
        FormObject[item.SystemKey] =
          item?.InputType == 6 && item?.typeName == "text"
            ? "int"
            : item.backendType;
      if(item?.SystemKey!="Description" && item?.SystemKey!="RequesterPositionId" &&  item?.SystemKey!="RequesterPositionIdDescription"){// اگر ایزورک فلو فعال باشد نباید اینپوت های دسکریپشن و رکوئستر بفرستیم
         FormObject2.push({
          ...defaultForm,
         "DataType": item?.InputType == 6 && item?.typeName == "text"
             ? "int"
             : (item.backendType=="bit" ?"bool" :item.backendType ),
         "Label": item.label?item.label :item.SystemKey ,
         "MinValue": item.min,
         "MaxValue": item.max,
         "DefaultValue": item.defaultValue? item.defaultValue:null,
         "WithTime":item.WithTime ?  item.WithTime== "withTime" :null,
         "MaxLength": +item.maxLength==0 ?null :+item.maxLength,
         "MinLength": +item.minLength,
         "Options": (item.typeName === 'selectBox' || item.typeName === 'RadioButton') ?  item.keyWords : null,
         "SystemKey": item.SystemKey ,
         "OldSystemKey": item.SystemKey ,
         "Step": stepIndex,
         "Required": item.required,
         "IsIdentity": item.SystemKey === "SystemNumber" ? true : false,
         "Condition": item.Condition ?? null,
         "Formula": item.Formula ?? null,



     })       } 
      }
      delete item.icon;
    });

})







    if (isStepUnvalued) {
      //return Toast(trans("duplicatekey"), "error");
      return Toast(trans("duplicatekey"),MessageType.error);

    }
    //به جای استیت اینفرمیشن فرم از دیتا که پارامتر تابع است استفاده میکنیم زیرا هنگام ادیت کردن با زدن دکمه ذخیره همزمان هم استیت ست میشود و هم درخواست پوت اجرا میشود و در این حالت به دلیل همزمانی مقدار استیت هنوز پر نشده و به جای ان مقدار تعیین شده را از طریق تابع با نام دیتا پاس می دهیم
    
    if(createGrid){


    if(gridPageMode=='create'){
   let GridData =  {
      "SystemKey":designMode?informationForm.DynamicForms?.SystemKey??data.DynamicForms?.SystemKey:data.DynamicForms?.SystemKey,
      "Title": designMode?informationForm.DynamicForms?.formTitle??data.DynamicForms?.formTitle:data.DynamicForms?.formTitle,
      "TitleEN":designMode? informationForm.DynamicForms?.FormTitleEN??data.DynamicForms?.FormTitleEN:data.DynamicForms?.FormTitleEN,
      "DataGridObject":JSON.stringify(FormObject) ,
      "DataGridFields": JSON.stringify({inputList:inputList ,formula:JSON.parse(JSON.stringify(formula).replaceAll('Step','Card')) ,condition:JSON.parse(JSON.stringify(condition).replaceAll('Step','Card')),}),
      "DataGridLables": JSON.stringify(objectLabels),
      "Priority":designMode?informationForm.DynamicForms?.FormPriority? +informationForm.DynamicForms?.FormPriority:+data.DynamicForms?.FormPriority:+data.DynamicForms?.FormPriority,
    }
      await postGridForm(GridData, "post")
       reload && reload()


    }else{

      
      let GridData={} as any
      if(informationForm.DynamicForms){
    GridData  =  {
      "SystemKey":designMode?informationForm.DynamicForms?.SystemKey??data.DynamicForms?.SystemKey:data.DynamicForms?.SystemKey,
     "Title":designMode? informationForm.DynamicForms?.formTitle??data.DynamicForms?.formTitle:data.DynamicForms?.formTitle,
     "TitleEN":designMode? informationForm.DynamicForms?.FormTitleEN??data.DynamicForms?.FormTitleEN:data.DynamicForms?.FormTitleEN,
      "DataGridObject":JSON.stringify(FormObject) ,
      "DataGridFields": JSON.stringify({inputList:inputList ,formula:JSON.parse(JSON.stringify(formula)?.replaceAll('Step','Card')) ,condition:JSON.parse(JSON.stringify(condition)?.replaceAll('Step','Card')),}),
      "DataGridLables": JSON.stringify(objectLabels),
      "Priority":designMode?informationForm.DynamicForms?.FormPriority? +informationForm.DynamicForms?.FormPriority:+data.DynamicForms?.FormPriority:+data.DynamicForms?.FormPriority,
    }
      }
      else{

      GridData  =  {
      "SystemKey":designMode?informationForm?.SystemKey??data.DynamicForms?.SystemKey:data.DynamicForms?.SystemKey,
      "Title": designMode?informationForm?.formTitle??data.DynamicForms?.formTitle:data.DynamicForms?.formTitle,
      "TitleEN":designMode? informationForm?.FormTitleEN??data.DynamicForms?.FormTitleEN:data.DynamicForms?.FormTitleEN,
      "DataGridObject":JSON.stringify(FormObject) ,
      "DataGridFields": JSON.stringify({inputList:inputList ,formula:JSON.parse(JSON.stringify(formula)?.replaceAll('Step','Card')) ,condition:JSON.parse(JSON.stringify(condition)?.replaceAll('Step','Card')),}),
      "DataGridLables": JSON.stringify(objectLabels),
       "Priority":designMode?informationForm?.FormPriority? +informationForm?.FormPriority:+data.DynamicForms?.FormPriority:+data.DynamicForms?.FormPriority,
    }
      }
     await postGridForm({...GridData,Id:selectedObj?.Id}, "put")
       reload && reload()
    }
    
   if(closeInputsForm)  reload && reload()

    }else{

      try {   
        if (formMode == "create") {
          const DynamicForms = {
            FormTitle: informationForm.DynamicForms?.formTitle??data.DynamicForms?.formTitle,
            FormKey: informationForm.DynamicForms?.SystemKey??data.DynamicForms?.SystemKey,
            FormTitleEN: informationForm.DynamicForms?.FormTitleEN??data.DynamicForms?.FormTitleEN,
            FormFields: JSON.stringify({inputList:inputList ,formula:JSON.parse(JSON.stringify(formula).replaceAll('Step','Card')) ,condition:JSON.parse(JSON.stringify(condition).replaceAll('Step','Card')),}),
            FormObject: JSON.stringify(FormObject2),
            FormCards: "",
            IsWorkflowEnable: informationForm.DynamicForms?.IsWorkflowEnable??data.DynamicForms?.IsWorkflowEnable,
            HasSignature: informationForm.DynamicForms?.HasSignature??data.DynamicForms?.HasSignature,
            ObjectLabels: JSON.stringify(objectLabels),
            FormPriority:informationForm.DynamicForms?.FormPriority? +informationForm.DynamicForms?.FormPriority:+data.DynamicForms?.FormPriority,
          };
          const DynamicFormsAccesses = [
            {
              PositionId: layoutContext.currentUserPosition.PositionId,
            },
          ];
          
          await postForm({
            DynamicForms: DynamicForms,
            DynamicFormsAccesses: DynamicFormsAccesses,
            DynamicFormApplications: dynamicFormApplications,
            Keywords: kyW,
            DynamicFormDataGrids: DynamicFormDataGrids,
          });
        } else if (formMode == "edit") {
  
  
    
    const DynamicForms = {
      FormTitle:data.DynamicForms?.formTitle?data.DynamicForms?.formTitle: informationForm?.formTitle,
      FormKey:data.DynamicForms?.SystemKey?data.DynamicForms?.SystemKey: informationForm?.SystemKey,
      FormTitleEN:data.DynamicForms?.FormTitleEN?data.DynamicForms?.FormTitleEN: informationForm?.FormTitleEN,
      FormFields: JSON.stringify({inputList:inputList ,formula:JSON.parse(JSON.stringify(formula).replaceAll('Step','Card')) ,condition:JSON.parse(JSON.stringify(condition).replaceAll('Step','Card'))}),
      FormObject: JSON.stringify(FormObject2),
      FormCards: "",
      IsWorkflowEnable:data.DynamicForms?.IsWorkflowEnable??informationForm.IsWorkflowEnable,
      HasSignature:data.DynamicForms?.HasSignature?? informationForm.HasSignature,
      ObjectLabels: JSON.stringify(objectLabels),
      FormPriority:data.DynamicForms?.FormPriority? +data.DynamicForms?.FormPriority : informationForm?.FormPriority?informationForm?.FormPriority:1,
    }; 
    await putForm({
      DynamicForms: DynamicForms,
     // FormPriority:  DynamicForms?.FormPriority ?DynamicForms?.FormPriority : 1,
     Keywords: kyW,
     DynamicFormDataGrids: DynamicFormDataGrids,
      DynamicFormApplications:!closeInputsForm?data.DynamicFormApplications:informationForm?.DynamicFormApplications,
     
  
    });
  }
  
  
        
  
        if(closeInputsForm){//اگر در مود ادیت فر م مستر ابتدا ثبت شود باید مقادیر فرم مستر را نگه داریم و پاس دهیم ب فرم اینپوت ها که وقتی فرم اینپوت ها ثبت شد به  مقادیر جدید فرم مستر دسترسی داشته باشد و آن را ارسال کند.
          //این شرط برای جلوگیری از خالی کردن فرم مستر بعد از ثبت آن است.
  
          /////localStorage.removeItem(createGrid?"datatables": "formbuilder");


          sessionStorage.setItem("changingforms", "false");
    
          setCountList({
            text: 0,
            textArea: 0,
            number: 0,
            date: 0,
            time: 0,
            timeLength: 0,
            simpleGrid: 0,
            selectBox: 0,
            RadioButton: 0,
            checkBox: 0,
            ProgressBar: 0,
            price: 0,
            Message: 0,
            Step: 0,
            Position: 0,
            Person: 0,
            Sex: 0,
          });
          setToolBarType(createGrid ?1 :0);
          setFormMode("view");
          setInformationForm(null);
          sessionStorage.setItem("changingforms", "false");
          setUserChanges(false);
          setInputs([]);
          setForceUpdate(!forceUpdate);
          
        }
      
      } catch (error) {}
    }
    if (closeInputsForm){
const newData=   JSON.parse(localStorage.getItem("unSavedData") as any)??{}
            delete newData?.[createGrid?"datatables": "formbuilder"]
            if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }
          setAcceptRestroeData &&  setAcceptRestroeData(false)
    }
  

  };


  const swapElements = (index1, index2 , cardIndex) => {
    try {
      let newArray: any = [];
      if (
        (cardIndex==0 &&(index1 == 0 && index2 == -1) ) ||(cardIndex==inputs.length-1 && (index1 + 1 == inputs[cardIndex].inputList.length && index2 + 1 == inputs[cardIndex].inputList.length + 1))
      ) {
    
      } else {
        if ((index1 == 0 && index2 == -1)) {
          newArray = [...inputs];
          let temp = newArray[cardIndex].inputList[index1];
          newArray[cardIndex].inputList.splice(index1, 1)
          newArray[cardIndex-1].inputList.splice(newArray[cardIndex-1].inputList.length , 0,temp)
          setInputs(newArray);
        }else if( (index1 + 1 == inputs[cardIndex].inputList.length && index2 + 1 == inputs[cardIndex].inputList.length + 1)){
          newArray = [...inputs];
          let temp = newArray[cardIndex].inputList[index1];
          newArray[cardIndex].inputList.splice(index1, 1)
          newArray[cardIndex+1].inputList.splice(0, 0,temp)
          setInputs(newArray);
          
        }else{
          newArray = [...inputs];
          let temp = newArray[cardIndex].inputList[index1];
         
          newArray[cardIndex].inputList[index1] = newArray[cardIndex].inputList[index2];
          newArray[cardIndex].inputList[index2] = temp;
          setInputs(newArray);
          
  
        }
      }
    } catch (error) {
      
    }
  };
  const swapCardElements = (index1, index2 ) => {
    try {
      let newArray: any = [];
      if (
        ((index1 == 0 && index2 == -1) )
      ) {
      } else {


      newArray = [...inputs];
      let temp = newArray[index1];
      newArray[index1] = newArray[index2];
      newArray[index2] = temp;
      setInputs(newArray);

      }
    } catch (error) {
      
    }
  };

  const handlePaste = async (event) => {
    if (formMode != "view") {
      try {
        const clipboard = JSON.parse(await navigator.clipboard.readText())
       const text = clipboard?.inputList;


       
         setCondition(clipboard?.condition);
   

        setFormula(clipboard?.formula)
        let newInputs : any= [];
        
            let newCountList = countList;
                let InputFlatList = inputs.flatMap(item => item.inputList);

    
    if(InputFlatList.find(item=>item.typeName=='SystemNumber' || item.typeName=='attachment' || item.typeName=="activityStatus") ){
      return null
    }
      let totalPrevInputs=[]//متغییر برای جمع کردن المان های فرم اول که در نهایت به المان های کپی شده اضافه میشود
      if(text[0].inputList){
        text?.map((main)=>{
       let newInputList =[]  as any
       
       if (
         main.inputList?.length != 0 &&
         ((main.inputList[0].SystemKey && main.inputList[0].backendType) || main.inputList[0])
       ) {
         
         main.inputList.map((inputCopy, index) => {
          const filterItem=InputFlatList.filter(item=>((item?.typeNameEn && inputCopy?.typeNameEn)?  item?.typeNameEn==inputCopy?.typeNameEn: item?.typeName==inputCopy?.typeName))
               let count=filterItem?.length


const findItem=filterItem?.some(item=>item?.SystemKey==(item?.typeNameEn && inputCopy.typeNameEn?  item?.typeNameEn: item?.typeName)+count)
if(findItem){
  count+=1
}




            let newInput: any = null;
               inputs.flatMap(item => item.inputList).map((input, newIndex) => {  
                 if (
                   (inputCopy["SystemKey"] != "Description" &&
                     inputCopy["SystemKey"] != "RequesterPositionId")|| !(InputFlatList.length >2)
                   ) {
                     
                     let ischanage = false;
                     if (input["label"] == inputCopy["label"]) {
                       newInput = {
                         ...inputCopy,
                         label:inputCopy["SystemKey"] == "Description" || inputCopy["SystemKey"] == "RequesterPositionId"?inputCopy.label:input.label?count==0?input.label:input.label + count: count==0?input.typeName: input.typeName + count,
                       };
                       ischanage = true;
                     }
                
                   if (input["SystemKey"]?.toLowerCase() == inputCopy["SystemKey"]?.toLowerCase()) {
                
                     ischanage = true;
                     if (newInput == null) {
                       newInput = {
                         ...inputCopy,
                         SystemKey:inputCopy["SystemKey"] == "SystemNumber"?'SystemNumber':
                         inputCopy["SystemKey"] == "attachment"?"attachment":
                         inputCopy["SystemKey"] == "activityStatus"?"activityStatus"
                         :inputCopy["SystemKey"] == "RequesterPositionId"?'RequesterPositionId':
                         inputCopy["SystemKey"] == "Description"?'Description':
                          input.backendType!='guid'?count==0?inputCopy.initialSystemKey: inputCopy.initialSystemKey + count :
                          count==0?inputCopy.initialSystemKey +'Id':(inputCopy.initialSystemKey +count )+'Id',
                       };
                     } else {
   
                       newInput = {
                         ...newInput,
                         SystemKey:inputCopy["SystemKey"] == "SystemNumber"?'SystemNumber':
                         inputCopy["SystemKey"] == "attachment"?"attachment":
                         inputCopy["SystemKey"] == "activityStatus"?"activityStatus":
                         inputCopy["SystemKey"] == "RequesterPositionId"?'RequesterPositionId':
                         inputCopy["SystemKey"] == "Description"?'Description':
                         input.backendType!='guid'?  count==0?inputCopy.initialSystemKey: inputCopy.initialSystemKey + count
                         :count==0?inputCopy.initialSystemKey+"Id": inputCopy.initialSystemKey + count +"Id"
                         ,
                       };
                     }
                   }
                   if (ischanage) {
                     newCountList = {
                       ...newCountList,
                       [input.typeName]: count
                     };
                   }
                 }
               });
               if (
                 (inputCopy["SystemKey"] != "Description" &&
                 inputCopy["SystemKey"] != "RequesterPositionId"  )|| !(InputFlatList.length >2)
               )
               {
                 newInputList.push(newInput == null ? inputCopy : newInput)
                 if(!(InputFlatList.length >2)){//  در این مرحله اگر دوتا المان در فایل داشته باشیم و اون دو تا درخواست کننده و شرح باشد، با کپی کردن از داخل استیت اینپوتس حذف میشن تا در نهایت موقع سر جمع کردن دیتا چون از استیت اینپوتس کپی میگیریم این دوتا داخلش نمونه و جاشو با درخواست کننده و شرح کپی پر کنه
 
                 totalPrevInputs= inputs.map(prev=>{return {...prev,inputList:prev.inputList.filter(i=>
                 i["SystemKey"] != "Description" &&
                 i["SystemKey"] != "RequesterPositionId" 
    
                 )}})
                 
 totalPrevInputs=totalPrevInputs.filter((prev:any)=>prev.inputList.length)//حذف گام هایی که اینپوت لیست خالی است
 
               }else{//اگر تعداد المان از عدد دو بیشتر هست پس موقع کپی نباید درخواست کننده و شرح را از فرم اول پاک کنیم و نباید از درخواست کننده و شرح کپی استفاده کنیم پس مقدار استیت اینپوتس تغییر نمیدیم
                  totalPrevInputs=inputs
                     }
               }else{
                 totalPrevInputs=inputs
               }
             });
           }
           if(!!newInputList.length){
 
             newInputs.push({...main,inputList:newInputList}) 
             setInputs([ ...totalPrevInputs , ...newInputs])
           }
     
         })
        
      }else{
           text.map((inputCopy, index) => {
            let newInput: any = null;
           

          const filterItem=InputFlatList.filter(item=>((item?.typeNameEn && inputCopy?.typeNameEn)?  item?.typeNameEn==inputCopy?.typeNameEn: item?.typeName==inputCopy?.typeName))
               let count=filterItem?.length

const findItem=filterItem?.some(item=>item?.SystemKey==(item?.typeNameEn && inputCopy.typeNameEn?  item?.typeNameEn: item?.typeName)+count)
if(findItem){
  count+=1
}


         
            if(inputCopy.typeName != "Card"&&inputCopy.typeName != "Step"&&(inputCopy["SystemKey"] != "Description" &&
                inputCopy["SystemKey"] != "RequesterPositionId"  ) ){
              InputFlatList.map((input, newIndex) => {  
                if (
                  ((inputCopy["SystemKey"] != "Description" &&
                    inputCopy["SystemKey"] != "RequesterPositionId")|| !(InputFlatList.length >2))&&   input.typeName != "Card"&&input.typeName != "Step"
                  ) {
                    
                    let ischanage = false;
                    if (input["label"] == inputCopy["label"]) {
                      newInput = {
                        ...inputCopy,
                        label:input.label?count==0?input.label:input.label + count: count==0?input.typeName: input.typeName + count,
                      };
                      ischanage = true;
                    }
               
                  if (input["SystemKey"].toLowerCase() == inputCopy["SystemKey"].toLowerCase()) {
               
                    ischanage = true;
                    if (newInput == null) {
                      newInput = {
                        ...inputCopy,
                        SystemKey:inputCopy["SystemKey"] == "SystemNumber"?'SystemNumber':
                        inputCopy["SystemKey"] == "attachment"?"attachment":
                        inputCopy["SystemKey"] == "activityStatus"?"activityStatus":
                        inputCopy["SystemKey"] == "RequesterPositionId"?'RequesterPositionId':
                        inputCopy["SystemKey"] == "Description"?'Description':
                         input.backendType!='guid'?count==0?inputCopy.initialSystemKey: inputCopy.initialSystemKey + count :
                         count==0?inputCopy.initialSystemKey +'Id':(inputCopy.initialSystemKey +count )+'Id'
                         ,
                      };
                    } else {
  
                      newInput = {
                        ...newInput,
                        SystemKey:inputCopy["SystemKey"] == "SystemNumber"?'SystemNumber':
                        inputCopy["SystemKey"] == "attachment"?"attachment":
                        inputCopy["SystemKey"] == "activityStatus"?"activityStatus"
                        :inputCopy["SystemKey"] == "RequesterPositionId"?'RequesterPositionId':
                        inputCopy["SystemKey"] == "Description"?'Description':
                        input.backendType!='guid'?  count==0?inputCopy.initialSystemKey: inputCopy.initialSystemKey + count
                        :count==0?inputCopy.initialSystemKey+"Id": inputCopy.initialSystemKey + count +"Id"
                        ,
                      };
                    }
                  }
                  if (ischanage) {
                    newCountList = {
                      ...newCountList,
                      [input.typeName]: count
                    };
                  }
                }
              });
              if (
                (inputCopy["SystemKey"] != "Description" &&
                inputCopy["SystemKey"] != "RequesterPositionId"  )|| !(InputFlatList.length >2)
              )
               {
                newInputs = [
                  ...newInputs,
                  newInput == null ? inputCopy : newInput,
                ];}
            }
          });
          if (newInputs != null) {
            if(inputs.length >2){
              setInputs([...inputs , {

                  type: InputTypes.card,
                 //// type: InputTypes.Step,
                  typeName: "Card",
                  stepNumber:1,
                  ////typeName: "Step",
                  initialSystemKey:"copyCard",
                  ////initialSystemKey:"copyStep",
                  backendType: "",
                  label: "copyCard" ,
                  ////label: "copyStep" ,
                  size:  12,
                  icon:["far", 'fa-square'],
                  ////icon: ["fas", 'object-ungroup'],
                  isOpen: true,
                  InputType: "0",
                  ////InputType: "0",
                  Keywords: [],
                  inputList : newInputs,
                  SystemKey:"copyCard"
                  // SystemKey:"copyStep"

              }]);
            }else{
              setInputs([...inputs,{

                  ////type: InputTypes.Step,
                  ////typeName: "Step",
                 //// initialSystemKey:"copyStep",
                  ////backendType: "",
                 //// label: "copyStep" ,
                 //// size:  12,
                ////  icon: ["fas", 'object-ungroup'],
                ////  isOpen: true,
                ////  InputType: "0",
                ////  Keywords: [],
                 //// inpuList : newInputs,
                 //// SystetmKey:"copyStep"
                  type: InputTypes.card,
                  typeName: "Card",
                  stepNumber:1,
                  initialSystemKey:"copyCard",
                  backendType: "",
                  label: "copyCard" ,
                  size:  12,
                  icon:["far", 'fa-square'],
                  isOpen: true,
                  InputType: "0",
                  Keywords: [],
                  inputList : newInputs,
                  SystemKey:"copyCard"
              }]);

            }
            setCountList(newCountList);
            setUserChanges(true);
          }
      }
        


        } catch (error) {
    

        Toast(trans('Msg_InvalidData'), MessageType.error);

      }
    }
  };



  const handleEditForm = async (formKey) => {
    try {
      const res = await checkForm(formKey);
      if (res) {
        getFormByNameAsync(formKey);
        setFormMode("edit");
      }
    } catch (err: any) {}
  };


  const cancelFun = () => {
    // Toast(trans("modalclosemessage"), "warning", "confirm", () => {
    //   localStorage.removeItem("formbuilder");
    //   sessionStorage.setItem("changingforms", "false");
    //   setCountList({
    //     text: 0,
    //     textArea: 0,
    //     number: 0,
    //     date: 0,
    //     time: 0,
    //     timeLength: 0,
    //     selectBox: 0,
    //     RadioButton: 0,
    //     checkBox: 0,
    //     ProgressBar: 0,
    //     price: 0,
    //     Message: 0,
    //     Step: 0,
    //     Position: 0,
    //     Person: 0,
    //     Sex: 0,
    //   });
    //   setInformationForm(null);
    //   setToolBarType(0);
    //   setFormMode("view");
    //   setInputs([]);
    // });
    Toast(trans("modalclosemessage"), MessageType.confirm, () => {
      /////localStorage.removeItem(createGrid?"datatables": "formbuilder");
              const newData= JSON.parse(localStorage.getItem("unSavedData") as any)??{}

            delete newData?.[createGrid?"datatables": "formbuilder"]
           if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }
      sessionStorage.setItem("changingforms", "false");
      setCountList({
        text: 0,
        textArea: 0,
        number: 0,
        date: 0,
        time: 0,
        timeLength: 0,
        simpleGrid: 0,
        selectBox: 0,
        RadioButton: 0,
        checkBox: 0,
        ProgressBar: 0,
        price: 0,
        Message: 0,
        Step: 0,
        Position: 0,
        Person: 0,
        Sex: 0,
      });
      setInformationForm(null);
      setToolBarType(createGrid ?1 :0);
      setFormMode("view");
      setInputs([]);
    });
  };

  const checkDrag = async (event, Obj, index , cardIndex) => {
 const scrollBox = event.target;
 const bounds = scrollBox.getBoundingClientRect();
 const yFromTop = event.clientY - bounds.top;

 if (yFromTop>0 && event.target.className.includes("simple-grid") && !event.target.className.includes("simple-grid__body-cell")) {
  return null
  } 

    await setTimeout(() => {
      checkTimeHold = true;
      if (checkTimeHold && checkClickHold) {
        if (formMode != "view") handleSelectMove(Obj, index ,cardIndex);
      } else {
         setEditInput(Obj);
        setIndexEditInput({index, cardIndex});
        if (formMode != "view"){
          if(!event.target.className.includes("simple-grid")){
            setInputMode("edit")
            setShowSetting(true);
          }
        };

      }
    }, 500);

                                    
  };

  const handleSelectMove = (e, index ,cardIndex) => {
    let newInputs = [...inputs];
    setDragItem(e);
    setIndexEditInput({index , cardIndex});
    setColSelectMove(e.size);
    newInputs[cardIndex].inputList.splice(index, 1);
    setInputs(newInputs);
  };

  const CheckExistAsync = async (e,data) => {
    try {
      const respons = await CheckExist(
        data.DynamicForms.SystemKey, 
        data.DynamicForms.formTitle,
        data.DynamicForms?.Id
      );
      if (!respons.Data) {
        if (formMode == "create") {
          if(!acceptRestroeData ){
 if (data.DynamicForms.IsWorkflowEnable){
                setInputs( [{inputList : [Requester, ActivityStatus,defaultDescription] , label:trans("Card"),SystemKey:"Card",stepNumber:1,backendType: "",isOpen: true,size: 12,type: 18,typeName: "Card" }] );
                ////setInputs( [{inputList : [Requester, defaultDescription] , label:trans("Step"),SystemKey:"Step",backendType: "",isOpen: true,size: 12,type: 14,typeName: "Step" }] );
              }
          else {
            setInputs( [{inputList : [ActivityStatus] , label:trans("Card"),SystemKey:"Card",backendType: "",isOpen: true,size: 12,type: 18,stepNumber:1,typeName: "Card" }] ); 
            ////setInputs( [{inputList : [] , label:trans("Step"),SystemKey:"Step",backendType: "",isOpen: true,size: 12,type: 14,typeName: "Step" }] ); 
          }
          }     
          setShowCreateForm(false);
          setToolBarType(1);
          setInformationForm(data);
        } else if (formMode == "edit") {
          setShowCreateForm(false);
          setToolBarType(createGrid ?1 :0); 
          setInformationForm({...data.DynamicForms,DynamicFormApplications:data.DynamicFormApplications});
        }

if(( createGrid ) || (formMode == "edit" && !createGrid)){
let changedInput=[] as any

          if(data?.DynamicForms?.IsWorkflowEnable || data?.IsWorkflowEnable){


if(!(inputs.flatMap(item=>item.inputList).some(item=>item?.SystemKey=="RequesterPositionId"))){
  if(!(inputs.flatMap(item=>item.inputList).some(item=>item?.SystemKey=="activityStatus"))){
  changedInput=inputs.map((item,index)=>index==0?{...item,inputList:[...item.inputList,Requester,ActivityStatus,defaultDescription]}:item)}
  else{
    changedInput=inputs.map((item,index)=>index==0?{...item,inputList:[...item.inputList,Requester,defaultDescription]}:item)}
 
}
else{
  changedInput=inputs
}

          }else{
const newInput=[] as any

inputs.map((card)=>{
const newInputOfCard=  card.inputList.filter(item=>item.SystemKey!="RequesterPositionId" && item.SystemKey!="Description")

newInput.push({...card,inputList:newInputOfCard})

})
changedInput=newInput


}
setInputs(changedInput)

          setIsWorkflowEnable(data?.DynamicForms?.IsWorkflowEnable || data?.IsWorkflowEnable)
          sendData(e,data,false,changedInput)
        


  
}
      }
       else {
        Toast(trans(respons?.Message), MessageType.error)
      }
    } catch (error) {}
  };

  const getDictionaryAvailableAsync = async () => {
    const respons = await getDictionaryAvailable();
    const respons2 = await getDataGridAvailable();
 
    let data = [
      ...DictionaryAvailable,
        ...respons.Data.Data.map((item) => {
          return {
            typeName: item.Title,
            KeyId: item.Id ,
            typeNameEn: item.SystemKey,
            SystemKey: item.SystemKey,
            type: InputTypes.DynamicDictionary,
            backendType: "string",
          };
        }),
        ...respons2.Data.map((item) => {
          return {
            typeName: item.Title,
            KeyId:item.Id,
            typeNameEn: item.SystemKey,
            SystemKey: item.SystemKey,
            type: InputTypes.dataGrid,
            backendType: "",
          };
        }),
      ]
 
    setDataDictionary(data);
      try {
    } catch (error) {}
  };

  const handleCloseCreateForm = () => {
    if (formMode == "create") {
      if (inputs.length <= 0) {
        setCountList({
          text: 0,
          textArea: 0,
          number: 0,
          date: 0,
          time: 0,
          timeLength: 0,
          simpleGrid: 0,
          selectBox: 0,
          RadioButton: 0,
          checkBox: 0,
          ProgressBar: 0,
          price: 0,
          Message: 0,
          Step: 0,
          Position: 0,
          Person: 0,
          Sex: 0,
        });
        setInformationForm(null);
        setToolBarType(createGrid ?1 :0);
        setFormMode("view");
        setInputs([]);
        /////localStorage.removeItem(createGrid?"datatables": "formbuilder");
                  const newData=   JSON.parse(localStorage.getItem("unSavedData") as any)??{}
            delete newData?.[createGrid?"datatables": "formbuilder"]
           if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }
        sessionStorage.setItem("changingforms", "false");
      } else {  
        setFormMode("create");
      }
    } else {
      //  setToolBarType(0);
      //  setFormMode('view');
    }
    setShowCreateForm(false);
  };



  useEffect(() => {
    let newInputList =localStorage.getItem('unSavedData') && JSON.parse(
      localStorage.getItem('unSavedData') + ""
    )?.[createGrid?"datatables": "formbuilder"]
    if (
 newInputList &&
      newInputList.inputs.length > 0 &&
   ( newInputList?.detailForm?.DynamicForms != null || (newInputList?.detailForm != null && !newInputList?.detailForm?.DynamicForms)) &&
      newInputList?.countList != null
    ) {

     if(!createGrid) {  Toast(
        trans("areyousuretorecoverunsaveddata"),
      MessageType.confirm,
        () => {
          setInputs(newInputList?.inputs);
          setCondition(newInputList?.condition);

          setFormula(newInputList?.formula)
          setCountList(newInputList?.countList);
          setInformationForm(newInputList?.detailForm);
          setDynamicFormApplications(newInputList?.detailForm?.DynamicFormApplications);
          if (newInputList?.detailForm?.Id) {
            setFormMode("edit");
          } else {
            setFormMode("create");
          }
        },
        null,
        () => {
          /////localStorage.removeItem(createGrid?"datatables": "formbuilder");
                     const newData=   JSON.parse(localStorage.getItem("unSavedData") as any)??{}
            delete newData?.[createGrid?"datatables": "formbuilder"]
           if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }
          sessionStorage.setItem("changingforms", "false");
        }
      );}
      else{
        if(acceptRestroeData){
            if (newInputList?.detailForm?.DynamicForms?.Id || newInputList?.detailForm?.Id) {
                    setFormMode("edit");

          } else {
            setFormMode("create");
          
          }

          setInputs(newInputList?.inputs);
          setCondition(newInputList?.condition);

          setFormula(newInputList?.formula)
          setCountList(newInputList?.countList);
          setInformationForm(newInputList?.detailForm);
          setDynamicFormApplications(newInputList?.detailForm?.DynamicForms?.DynamicFormApplications || newInputList?.detailForm?.DynamicFormApplications);
        
        }else{
 const newData=   JSON.parse(localStorage.getItem("unSavedData") as any)??{}
            delete newData?.datatables
           if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }
          sessionStorage.setItem("changingforms", "false");
        }
      }
    }
    getDictionaryAvailableAsync();
  }, [resetForm]);
  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };


    async function getDynamicDataGridAsync() {
     
      
      setLoading(false);
      try {
        const res = await getDynamicDataGridApi(selectedObj?.Id);
     
        setInformationForm({DynamicForms:{
          formTitle:res.Title,
          FormTitleEN:res.TitleEN,
          FormPriority:res.Priority,
          SystemKey:res.SystemKey,
          Id:res.Id
        }});
        


        if(JSON.parse(res?.DataGridFields)?.inputList?.[0]?.inputList || JSON.parse(res?.DataGridFields)?.[0]?.inputList){
          // setInputs(JSON.parse(res?.DataGridFields))
     setInputs(JSON.parse(res?.DataGridFields)?.inputList ?JSON.parse(res?.DataGridFields)?.inputList: JSON.parse(res?.DataGridFields));

        }else{

          setInputs([
            {label:trans("Card"),stepNumber:1,SystemKey:"Card",backendType: "",isOpen: true,size: 12,type: 18,typeName: "Card",inputList:JSON.parse(res?.DataGridFields)?.inputList ?JSON.parse(res?.DataGridFields)?.inputList:JSON.parse(res?.DataGridFields)}
            ////{label:trans("Step"),SystemKey:"Step",backendType: "",isOpen: true,size: 12,type: 14,typeName: "Step",inputList:JSON.parse(res?.DataGridFields)}
          ])
        }
    
        setCondition((JSON.parse(res?.DataGridFields))?.condition || {});

          setFormula((JSON.parse( res?.DataGridFields))?.formula || {})
        
      } catch (err: any) {}
      setLoading(true);
    }
  

  useEffect(() => {
    if (userChanges) {
      sessionStorage.setItem("changingforms", "true");
      window.addEventListener("beforeunload", handleBeforeUnload);
    }
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [userChanges]);


useEffect(()=>{
  if(createGrid ){
    // if( gridPageMode=='create'){

    //   setFormMode('create')
    // }
    setShowCreateForm(true)
  }
},[createGrid])

  
  useEffect(() => {
    if (userChanges) {
      localStorage.setItem("unSavedData",
JSON.stringify({...JSON.parse(localStorage.getItem('unSavedData') as any),
[createGrid?"datatables": "formbuilder"]:{
          detailForm: informationForm,
          inputs: inputs,
          formula:formula,
          condition:condition,
          detailOfFormNotification:informationForm?.formTitle ?informationForm?.formTitle:informationForm?.DynamicForms?.formTitle,
          countList: countList,}

})

       ,
 
      );
    } 
    setLoading(true);
  }, [inputs]);

  useEffect(() => {
    if (dragItem != null) {
      document.addEventListener("mouseup", DropInput);
      document.addEventListener("mousemove", moveDragInput);
    } else {
    }
    return () => {
      document.removeEventListener("mousemove", moveDragInput);
      document.removeEventListener("mouseup", DropInput);
    };
  }, [dragItem]);



  useEffect(() => {
    setLoadingAfterSetting(true);
  }, [loadingAfterSetting]);
  useEffect(() => {
  
  }, [inputs]);



    useEffect(()=>{
    if(createGrid && formMode!='create' && !acceptRestroeData){
       getDynamicDataGridAsync()
    }
  },[])
    useEffect(()=>{
    if(localStorage.getItem("DefaultSettingFormBuilder")){
       setDefaultSettingObj(JSON.parse(localStorage.getItem("DefaultSettingFormBuilder")+""))
    }
  },[])

  return (
    <>
      {showFormInViewMode && (
        <ModalForm
          title={trans("viewForm")}
          show={showFormInViewMode}
          checkClose={false}
          onHide={() => {
            setShowFormInViewMode(false);
            //setFormMode("create");
            setPreview(false);
            setFormInViewMode(null);
          }}
        >
          <DynamicFormDataEntry
          formBuilderPage={true}
            defaultInputList={FormInViewMode ? null : inputs}
            firstAutoValue={false}
            formBuilderMode={!preview}
            EnableDisplacement={false}
            mode="view"
            handleCopy={(formKey) => {
              getFormByNameAsync(formKey, "copy");
              setShowFormInViewMode(false);
              setFormMode("create");
              setFormInViewMode(null);
            }}
            onHide={() => {
              setShowFormInViewMode(false);
             // setFormMode("create");
              setPreview(false);
              setFormInViewMode(null);
            }}
            copyPermission={true}
            formKey={FormInViewMode}
          />
        </ModalForm>
      )}

      {(  (showCreateForm && !createGrid)  || (createGrid && formMode=='create' && !designMode) || (createGrid && formMode!='create' && loading &&  !designMode)) && (
        <ModalForm
        buttonPrintObj={buttonPrintObj}
          title={
            trans(formMode + "Form") +
            (formMode != "create" ? " : " + (informationForm?.DynamicForms?.formTitle?informationForm?.DynamicForms?.formTitle:informationForm?.formTitle) : "")
          }
          show={showCreateForm}
          onHide={() => {
            handleCloseCreateForm();
            if(createGrid && formMode!='view'){
            reload &&  reload()
            }
          }}
        >
          <CreateInputForm
            mode={formMode}
            createGrid={createGrid}
            onHide={() => {
              handleCloseCreateForm();
            }}
            handleNewForm={(e,data) => {
              setDynamicFormApplications(data.DynamicFormApplications);
              setIsWorkflowEnable(data.IsWorkflowEnable);
              CheckExistAsync(e,data);
            }}
            obj={informationForm}
          />
        </ModalForm>
      )}


{console.log(createGrid , designMode , formMode=='view'  ,  !createGrid)
}

      {((createGrid && (designMode || formMode=='view') ) ||  !createGrid) &&  <div className="row m-0 p-0 position-relative formBuilder userSelectNone">
        <ListToolBar
        createGrid={createGrid}
        gridPageMode={gridPageMode}
          setToolBarType={setToolBarType}
          setFormMode={setFormMode}
          handleReset={() => {
            setInformationForm(null);
            setInputs([]);
          } }
          getFormByNameDownloadAsync={getFormByNameDownloadAsync}
          selectedObj={selectedObj}
          toolBarType={toolBarType}
          formMode={formMode}
          informationForm={informationForm}
          selectInput={selectInput}
          getFormByNameAsync={getFormByNameAsync}
          setShowCreateForm={setShowCreateForm}
          setDefaultSettingObj={setDefaultSettingObj}
          disableMode={showSetting || deleteTimerMode}
          reload={forceUpdate}
       />
      {/*   <div
          className={`d-flex flex-column justify-content-between position-relative p-0 col-2 glassBox formBuilder__toolBar border-0 ${
            (showSetting || deleteTimerMode) && "disableMode"
          } `}
        >
          <div className="">
            <div className={`d-flex formBuilder__toolBar__header `}>
              <div
                onClick={() => {
                  setToolBarType(0);
                }}
                className={`formBuilder__toolBar__header__title text-center p-2 w-100 ${
                  !toolBarType
                    ? " color_text_black"
                    : formMode != "view"
                    ? "color_text_primary formBuilder__toolBar__header__disableTitle"
                    : "color_text_primary formBuilder__toolBar__header__disableTitle   "
                }`}
              >
                {trans("forms")}
              </div>
              <div
                onClick={() => {
                  setToolBarType(2);
                  if (informationForm != null) {
                    if (formMode != "view") {
                    }
                  }
                }}
                className={`formBuilder__toolBar__header__title text-center p-2 w-100 ${
                  toolBarType == 2
                    ? "color_text_black"
                    : formMode != "view"
                    ? "color_text_primary formBuilder__toolBar__header__disableTitle"
                    : " color_text_primary formBuilder__toolBar__header__disableTitle"
                }`}
              >
                {trans("databox")}
              </div>
              <div
                onClick={() => {
                  setToolBarType(1);
                  if (informationForm != null) {
                    if (formMode != "view") {
                    }
                  }
                }}
                className={`formBuilder__toolBar__header__title text-center p-2 w-100 ${
                  toolBarType == 1
                    ? "color_text_black"
                    : formMode != "view"
                    ? "color_text_primary formBuilder__toolBar__header__disableTitle"
                    : " color_text_primary formBuilder__toolBar__header__disableTitle"
                }`}
              >
                {trans("toolBox")}
              </div>
            </div>
            <ul
              className={` posiion-relative p-1 formBuilder__toolBar__body position-relative`}
            >
              {toolBarType ? (
                <>
                  {toolBarType == 1
                    ? InputAvailable.map(
                        (e: any) =>
                          e.typeName != "PositionDictionary" && (
                            <li
                              className=""
                              onMouseDown={(event) => {
                                if (formMode != "view") selectInput(e, event);
                              }}
                            >
                              <div className=" glassBox p-2 border border-1 m-1 d-flex justify-content-between align-items-center formBuilder__toolBar__body__items">
                                <div className="showDots">
                                  {trans(e.typeName)}
                                </div>
                                <FontAwesomeIcon icon={e.icon} />
                              </div>
                            </li>
                          )
                      )
                    : dataDictionary.map(
                        (e: any) =>
                          e.typeName != "PositionDictionary" && (
                            <li
                              className=""
                            >
                              <div className=" glassBox  p-2 border border-1 m-1 d-flex justify-content-between align-items-center formBuilder__toolBar__body__items">
                                <div className="showDots w-100 row justify-content-between">
                                  <div className="col-9"
                                      onMouseDown={(event) => {
                                if (formMode != "view") selectInput(e, event);
                              }}
                                  >
                                  {trans(e.typeName)}</div>
                              {e.type==InputTypes.dataGrid &&    <div 
                                   onClick={()=>{
                                    setShowDataGridForm(true);
                                    setDataGridFormMode('edit')
                                
                                    
                                     setSelectedDataCollectionEditing(e)
                                    
                                   }}
                                  className="col-auto text-start px-0" style={
                                    {cursor:'pointer'}
                                  }>
                                <FontAwesomeIcon icon={'edit'} /></div>}

                                </div>
                              </div>
                            </li>
                          )
                      )}
                </>
              ) : (
                <>
                  {formsLoading ? (
                    <ul className="">
                      {forms?.map((form, index) => (
                        <li
                          className={`m-2 p-2 glassBox formBuilder__toolBar__body__form ${
                            informationForm?.SystemKey == form.FormKey
                              ? " formBuilder__toolBar__body__form__active"
                              : ""
                          }`}
                          onClick={() => {
                            getFormByNameAsync(form.FormKey);
                            setFormMode("view");
                          }}
                        >
                          <div>
                            <div className="showDots formBuilder__toolBar__body__form__title">
                              {form?.FormTitle}
                            </div>
                          </div>
                          <div className="d-flex justify-content-between">
                            <div className="text-muted showDots formBuilder__toolBar__body__form__sub">
                              {form?.FormKey}
                            </div>
                            <div className="d-flex">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  getFormByNameAsync(form.FormKey, "copy");
                                }}
                                className="btn btn-sm ms-1 btn-warning d-flex justify-content-center align-items-center customBtnSize"
                              >
                                <FontAwesomeIcon icon={["fas", "copy"]} />
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  getFormByNameAsync(form.FormKey);
                                  setFormMode("view");
                                }}
                                className="btn btn-sm ms-1 btn-success d-flex justify-content-center align-items-center customBtnSize"
                              >
                                <FontAwesomeIcon icon={["fas", "eye"]} />
                              </button>
                              {formMode == "view" && (
                                <>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      getFormByNameAsync(form.FormKey , null , ()=>{  setFormMode("edit");
                                        setShowCreateForm(true)} );

                                    }}
                                    className="btn btn-sm ms-1 btn-primary d-flex justify-content-center align-items-center customBtnSize"
                                  >
                                    <FontAwesomeIcon icon={["fas", "edit"]} />
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteForms(form.FormKey);
                                    }}
                                    className="btn btn-sm ms-1 btn-danger d-flex justify-content-center align-items-center customBtnSize"
                                  >
                                    <FontAwesomeIcon icon={["fas", "trash"]} />
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <Loading />
                  )}
                </>
              )}
            </ul>
          </div>
          {!toolBarType && (
            <div className="d-flex">
              <button
                disabled={formMode != "view" ? true : false}
                onClick={() => {
                  setShowDefaultSetting(true);
                }}
                className="d-flex align-items-center justify-content-center btn btn-primary w-25 ms-1 "
              >
                <FontAwesomeIcon icon={["fas", "gear"]} />
              </button>
              <button
                disabled={formMode != "view" ? true : false}
                onClick={() => {
                  setInformationForm(null);
                  setShowCreateForm(true);
                  setFormMode("create");
                }}
                className="btn btn-primary w-75 "
              >
                {trans("createform")}{" "}
              </button>
            </div>
          )}

          {toolBarType == 2 && (
            <div className="d-flex  row justify-content-center">
              <div className="col-6">
              <button
                onClick={() => {
                  setShowDataCollectForm(true);
                  //  setFormMode("create");
                
                }}
                style={{fontSize:'12px'}}
                className="btn px-0 btn-primary w-100 "
              >
                {trans('DataSetProperties')}
              </button>
              </div>
            
<div className="col-6">
<button
                onClick={() => {
                 
                  setShowDataGridForm(true);
                  setDataGridFormMode("create");
                }}
                style={{fontSize:'12px'}}
                className="btn px-0 btn-primary w-100 "
              >
                {trans('DataTables')}
              </button>
</div>
        
            </div>
          )}
        </div> */}

        <div className={`${showSetting ? "col-8" : "col-10"} `}>
          <div
            onMouseUp={(e) => {
              checkClickHold = false;
              dragItem && addNewInput(dragItem, -1 ,0);
            }}
            ref={formBx}
            className={` formBoxDr glassBox border-0 position-relative`}
            style={{ height: "85vh" }}
          >
            {(showSetting || deleteTimerMode) && (
              <div
                className="position-absolute w-100 h-100 top-0 left-0"
                style={{
                  zIndex: "5",
                  backgroundColor: "#495057",
                  opacity: 0.5,
                  borderRadius: "0.25rem",
                }}
              ></div>
            )}

            <>
              {loading && loadingAfterSetting ? (
                inputs.length > 0 && (
                  <>
                    <div
                      className="modal-form__content-header modal-header alert-primary"
                      style={{ cursor: "unset" }}
                    >
                      <strong
                        onClick={() => {
                          setShowCreateForm(true);
                        }}
                        className="Modaltitle"
                        id="modal-form__title"
                        style={{ cursor: "pointer" }}
                      >
                        {informationForm?.formTitle ?informationForm?.formTitle:informationForm?.DynamicForms?.formTitle}
                      </strong>
                      <div className="d-flex">
                        
        
           
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 300, hide: 0 }}
                          overlay={
                            <Tooltip
                              className="tooltip"
                              id={`button-tooltip-${"paste"}`}
                            >
                              {trans("paste")}
                            </Tooltip>
                          }
                        >
                          <FontAwesomeIcon
                            icon={["fas", "paste"]}
                            onClick={(e) => {
                              if (informationForm != null && formMode != "view")
                                handlePaste(e);
                            }}
                            className={
                              informationForm == null || formMode == "view"
                                ? "text-muted"
                                : ""
                            }
                            style={{ cursor: "pointer", marginLeft: "10px" }}
                          />
                        </OverlayTrigger>

    <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 300, hide: 0 }}
                          overlay={
                            <Tooltip
                              className="tooltip"
                              id={`button-tooltip-${"view"}`}
                            >
                              {trans("view")}
                            </Tooltip>
                          }
                        >
                          <FontAwesomeIcon
                            icon={["fas", "eye"]}
                            onClick={() => {
                              if (
                                informationForm != null &&
                                inputs.length > 0
                              ) {
                                setShowFormInViewMode(true);
                                setPreview(true);
                              }
                            }}
                            className={
                              inputs.length <= 0 && informationForm != null
                                ? "text-muted"
                                : ""
                            }
                            style={{ cursor: "pointer", marginLeft: "10px" }}
                          />
                        </OverlayTrigger>

                          {inputs.length > 0 && formMode != "view" && (
                          <>
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 300, hide: 0 }}
                              overlay={
                                <Tooltip
                                  className="tooltip"
                                  id={`button-tooltip-${"save"}`}
                                >
                                  {trans("save")}
                                </Tooltip>
                              }
                            >
                              <FontAwesomeIcon
                                icon={["fas", "save"]}
                                onClick={(e) => {
                                  sendData(e);
                                    if(formMode!=='edit'){
                                    }  
                                }}
                                className={
                                  inputs.length <= 0 && informationForm != null
                                    ? "text-muted"
                                    : ""
                                }
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "10px",
                                }}
                              />
                            </OverlayTrigger>

                          </>
                        )}

                { ((createGrid && formMode!='view' ) || !createGrid   ) &&   <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 300, hide: 0 }}
                          overlay={
                            <Tooltip
                              className="tooltip"
                              id={`button-tooltip-${"edit"}`}
                            >
                              {trans("edit")}
                            </Tooltip>
                          }
                        >
                          <FontAwesomeIcon
                            icon={["fas", "edit"]}
                            onClick={() => {
                              if (informationForm != null) {
                                setFormMode("edit");
                                setToolBarType(1);
                              }
                            }}
                            className={
                              (inputs.length <= 0 && informationForm != null) || formMode=="edit"
                                ? "text-muted"
                                : ""
                            }
                            style={{ cursor: "pointer", marginLeft: "10px",opacity:formMode=="edit"?'0.5':'1' }}
                          />
                        </OverlayTrigger>}

                    

                      
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 300, hide: 0 }}
                              overlay={
                                <Tooltip
                                  className="tooltip"
                                  id={`button-tooltip-${"cancel"}`}
                                >
                                  {trans("cancel")}
                                </Tooltip>
                              }
                            >
                              <FontAwesomeIcon
                                icon={["fas", "close"]}
                                onClick={cancelFun}
                                className={
                                  inputs.length <= 0 && informationForm != null
                                    ? "text-muted"
                                    : ""
                                }
                                style={{ cursor: "pointer" }}
                              />
                            </OverlayTrigger>
                      </div>
                    </div>
                    <div className="card row mx-2 mt-1 formBuilder__formBx" style={{flexDirection:"column" ,flexWrap: "inherit"}}>
                      <>

                        {inputs.map((card , cardIndex)=>(
                          <>
                            {(showResetBtn &&
                                  selectingItemForDelete.index == -1 &&selectingItemForDelete.cardIndex == cardIndex )&& (
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                      className="position-absolute p-1  top-0 right-0 text-white w-100 h-100 d-flex align-items-center justify-content-center blockBox "
                                      style={{ zIndex: "6" }}
                                    >
                                      <div className="timerCircleBox m-2">
                                        <svg>
                                          <circle r="13" cx="15" cy="15"></circle>
                                        </svg>
                                      </div>
                                      <OverlayTrigger
                                        key={"delete"}
                                        placement="top"
                                        delay={{ show: 300, hide: 0 }}
                                        overlay={
                                          <Tooltip
                                            className="tooltip"
                                            id={`button-tooltip-${"checkable"}`}
                                          >
                                            {trans("delete")}
                                          </Tooltip>
                                        }
                                      >
                                        <div
                                          style={{
                                            height: "30px",
                                            width: "30px",
                                          }}
                                          onMouseDown={(e) => {
                                            e.stopPropagation();
                                          }}
                                          className="d-flex align-items-center justify-content-center position-relative btn btn-danger p-1 m-2"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            removeInput(e, cardIndex, "confirmDeleteCard", cardIndex)
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            size="sm"
                                            color={
                                              formMode == "view" ? "gray" : ""
                                            }
                                            icon={["fas", "trash"]}
                                          />
                                        </div>
                                      </OverlayTrigger>
                                      <OverlayTrigger
                                        key={"undo"}
                                        placement="top"
                                        delay={{ show: 300, hide: 0 }}
                                        overlay={
                                          <Tooltip
                                            className="tooltip"
                                            id={`button-tooltip-${"checkable"}`}
                                          >
                                            {trans("undo")}
                                          </Tooltip>
                                        }
                                      >
                                        <div
                                          style={{
                                            height: "30px",
                                            width: "30px",
                                          }}
                                          onMouseDown={(e) => {
                                            e.stopPropagation();
                                          }}
                                          className="d-flex align-items-center justify-content-center position-relative btn btn-success p-1 m-2"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            removeInput(e, cardIndex, "cancelDelete", cardIndex);
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            size="sm"
                                            color={
                                              formMode == "view" ? "gray" : ""
                                            }
                                            icon={["fas", "rotate-right"]}
                                          />
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                  )}
                          <div  
                                    id={"cardId"+cardIndex}
                                   onMouseEnter={(e) => {
                                  if(card.inputList.length==0){
                                  document.getElementById("ViewBox")?.remove();
                                  showspace("Obj",cardIndex+ "inputsId" + 0 ,cardIndex);
                                  if (!dragItem) {
                                    setSelectInputForm(true);
                                  }
                                }
                          }}
                          style={{minHeight:"100px" , flexDirection:"row"}} className="card row mx-0  px-0 my-3 align-items-center">
                        {inputs.length>1 &&
                        <div
                               onClick={(p) => {
                                        if (formMode != "view") {
                                          setInputMode("edit");
                                          setShowSetting(true);
                                          setEditInput(card);
                                          setIndexEditInput({index:-1 , cardIndex});
                                        }
                                      }}
                        style={{ backgroundColor: "#cfe2ff", paddingRight: "20px", justifyContent: "space-between" }} className="formBuilder__formBx__items  d-flex  py-1 col-12 pr-4">
                                <div>{card.label=='card'?trans(card.label):card.label  } </div>
                          {   formMode!='view' &&  <div className="d-flex row"> 

                               <div
                                      onClick={(e) => {
                                                  e.stopPropagation();
                                        swapCardElements(cardIndex, cardIndex - 1 );
                                      }}
                                      className={`${
                                        "d-none"
                                      
                                      } text-white align-items-center justify-content-center m-1  p-1 formBuilder__formBx__items__btn btn btn-info `}
                                    >
                                      <FontAwesomeIcon
                                        size="xs"
                                        // color={formMode == "view" ? "gray" : ""}
                                        icon={["fas", "arrow-up"]}
                                      />
                                    </div>
                                    <div
                                      onClick={(e) => {
                                         e.stopPropagation();
                                        swapCardElements(cardIndex, cardIndex + 1 );
                                      }}
                                      className={`${
                                       "d-none"
                                 
                                      } text-white align-items-center justify-content-center m-1  p-1 formBuilder__formBx__items__btn btn btn-info `}
                                    >
                                      <FontAwesomeIcon
                                        size="xs"
                                        // color={formMode == "view" ? "gray" : ""}
                                        icon={["fas", "arrow-down"]}
                                      />
                                    </div>
                                    <div
                                      onMouseMove={(e) => {
                                        e.stopPropagation();
                                        setStateBoxInput("edit");
                                      }}
                                      onMouseLeave={(e) => {
                                        setStateBoxInput(null);
                                      }}
                                      onClick={(p) => {
                                        // if (formMode != "view") {
                                          setInputMode("edit");
                                          setShowSetting(true);
                                          setEditInput(card);
                                          setIndexEditInput({index:-1 , cardIndex});
                                        // }
                                      }}
                                      className={`${
                                        "d-none"
                                     
                                      } btn btn-primary text-white align-items-center justify-content-center p-1 m-1 formBuilder__formBx__items__btn`}
                                    >
                                      <FontAwesomeIcon
                                        size="xs"
                                        // color={formMode == "view" ? "gray" : ""}
                                        icon={["fas", "gear"]}
                                      />
                                    </div>
                                    <div
                                      onMouseMove={(e) => {
                                        e.stopPropagation();
                                        setStateBoxInput("delete");
                                      }}
                                      onMouseLeave={(e) => {
                                        setStateBoxInput(null);
                                      }}
                                      onClick={(p) => {
                                        p.stopPropagation();
                                          removeInput(p, cardIndex, "deleteCard", cardIndex);
                                      }}
                                      className={`${
                                       "d-none"
                                      } btn btn-danger text-white  align-items-center justify-content-center  p-1 m-1 formBuilder__formBx__items__btn`}
                                    >
                                      <FontAwesomeIcon
                                        size="xs"
                                        // color={formMode == "view" ? "gray" : ""}
                                        icon={["fas", "trash"]}
                                      />
                                    </div>
                            </div>}
                            <div style={{ marginLeft: "18px" }} onClick={() => {  }} >{true ? <FontAwesomeIcon icon={[ICON_TYPE, "angle-down"]} size="lg" className="icon" /> : <FontAwesomeIcon icon={[ICON_TYPE, "angle-up"]} size="lg" className="icon" />}</div>
                        </div>
                        }

                          {card.inputList.map((Obj, index) => {
                            if (Obj.typeName == "Card") {
                            ////if (Obj.typeName == "Step") {
                              flag = Obj.isOpen;
                            }

                            return (
                              <div
                                id={cardIndex+"inputsId" + index}
                                onMouseDown={(event) => {
                                  // checkClickHold = true;
                                  // checkDrag(event, Obj, index , cardIndex);
                                }}
                                onMouseEnter={(e) => {
                                  document.getElementById("ViewBox")?.remove();
                                  showspace(Obj, cardIndex+"inputsId" + index ,cardIndex);
                                  if (!dragItem) {
                                    setSelectInputForm(true);
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!dragItem) {
                                    setSelectInputForm(false);
                                  }
                                }}
                                className={`d-flex position-relative align-items-start formBuilder__formBx__active col-${Obj.size} formBoxDr in`}
                              >
                                {showResetBtn &&
                                  (selectingItemForDelete.index == index &&selectingItemForDelete.cardIndex == cardIndex ) && (
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                      className="position-absolute p-1  top-0 right-0 text-white w-100 h-100 d-flex align-items-center justify-content-center blockBox "
                                      style={{ zIndex: "6" }}
                                    >
                                      <div className="timerCircleBox m-2">
                                        <svg>
                                          <circle r="13" cx="15" cy="15"></circle>
                                        </svg>
                                      </div>
                                      <OverlayTrigger
                                        key={"delete"}
                                        placement="top"
                                        delay={{ show: 300, hide: 0 }}
                                        overlay={
                                          <Tooltip
                                            className="tooltip"
                                            id={`button-tooltip-${"checkable"}`}
                                          >
                                            {trans("delete")}
                                          </Tooltip>
                                        }
                                      >
                                        <div
                                          style={{
                                            height: "30px",
                                            width: "30px",
                                          }}
                                          onMouseDown={(e) => {
                                            e.stopPropagation();
                                          }}
                                          className="d-flex align-items-center justify-content-center position-relative btn btn-danger p-1 m-2"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            removeInput(
                                              e,
                                              index,
                                              "confirmDelete",
                                              cardIndex
                                            );
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            size="sm"
                                            color={
                                              formMode == "view" ? "gray" : ""
                                            }
                                            icon={["fas", "trash"]}
                                          />
                                        </div>
                                      </OverlayTrigger>
                                      <OverlayTrigger
                                        key={"undo"}
                                        placement="top"
                                        delay={{ show: 300, hide: 0 }}
                                        overlay={
                                          <Tooltip
                                            className="tooltip"
                                            id={`button-tooltip-${"checkable"}`}
                                          >
                                            {trans("undo")}
                                          </Tooltip>
                                        }
                                      >
                                        <div
                                          style={{
                                            height: "30px",
                                            width: "30px",
                                          }}
                                          onMouseDown={(e) => {
                                            e.stopPropagation();
                                          }}
                                          className="d-flex align-items-center justify-content-center position-relative btn btn-success p-1 m-2"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            removeInput(e, index, "cancelDelete" ,cardIndex);
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            size="sm"
                                            color={
                                              formMode == "view" ? "gray" : ""
                                            }
                                            icon={["fas", "rotate-right"]}
                                          />
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                  )}
                                <div
                                  onMouseDown={(event) => {
                                    checkClickHold = true;
                                    checkDrag(event, Obj, index , cardIndex);
                                  }}
                                  className={` align-items-start h-100 justify-content-between w-100 formBoxDr iwn ${
                                    !dragItem &&
                                    formMode != "view" &&
                                    "formBuilder__formBx__items"
                                  }`}
                                  id={index}
                                >
                                  
                                  <InputDetector
                                    hidden={!flag}
                                    stepperIndex={
                                      objectStep[inputs[cardIndex].inputList?.[index].SystemKey]
                                        ? objectStep[inputs[cardIndex].inputList?.[index].SystemKey]
                                            .label
                                        : Object.keys(objectStep).length + 1
                                    }
                                    mode={formMode}
                                    firstAutoValue={false}
                                    formBuilderMode={true}
                                    EnableDisplacement={
                                      formMode != "view" ? true : false
                                    }
                                    changeProperty={(e)=>{         
                                      // const count=inputs.filter(findItem=>findItem.typeName==e.typeName).length  
                                      // setInputs(inputs.map((item, index2)=>{if(index2==index){return {...item,... e,SystemKey:
                                      //   item.type==InputTypes.dataGrid && count>0 ?item.SystemKey + (count ) :  item.SystemKey
                                      // }}else return {...item,
                                      //   SystemKey:
                                      //   item.type==InputTypes.dataGrid && count>0 ?item.SystemKey + (count ) :  item.SystemKey
                                      // }}))
                                      const inputList=inputs[cardIndex].inputList.map((item, index2)=>{if(index2==index){return {... e,...item }}else return item})
                                        inputs[cardIndex].inputList=inputList
                                      setInputs(inputs.map((prevItem,prevIndex)=>prevIndex==cardIndex?{...prevItem,inputList}:prevItem))
                                    }}
                                      typeName={Obj.typeName}
                                      property={Obj}
                                  />
                                  <div
                                    className="d-flex"
                                    onMouseDown={(e) => {
                                      e.stopPropagation();
                                      return false;
                                    }}
                                  >
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        swapElements(index, index - 1 , cardIndex);
                                      }}
                                      className={`${
                                        (showResetBtn &&
                                        selectingItemForDelete.index == index &&selectingItemForDelete.cardIndex == cardIndex)
                                          ? "d-flex"
                                          : "d-none"
                                      } text-white align-items-center justify-content-center m-1  p-1 formBuilder__formBx__items__btn btn btn-info `}
                                    >
                                      <FontAwesomeIcon
                                        size="xs"
                                        color={formMode == "view" ? "gray" : ""}
                                        icon={["fas", "arrow-up"]}
                                      />
                                    </div>
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        swapElements(index, index + 1 , cardIndex);
                                      }}
                                      className={`${
                                        (showResetBtn &&
                                        selectingItemForDelete.index == index &&selectingItemForDelete.cardIndex == cardIndex)
                                          ? "d-flex"
                                          : "d-none"
                                      } text-white align-items-center justify-content-center m-1  p-1 formBuilder__formBx__items__btn btn btn-info `}
                                    >
                                      <FontAwesomeIcon
                                        size="xs"
                                        color={formMode == "view" ? "gray" : ""}
                                        icon={["fas", "arrow-down"]}
                                      />
                                    </div>
                                    <div
                                      onMouseMove={(e) => {
                                        e.stopPropagation();
                                        setStateBoxInput("edit");
                                      }}
                                      onMouseLeave={(e) => {
                                        setStateBoxInput(null);
                                      }}
                                      onClick={(p) => {
                                        if (formMode != "view") {
                                          setInputMode("edit");
                                          setShowSetting(true);
                                          setEditInput(Obj);
                                          setIndexEditInput({index , cardIndex});
                                        }
                                      }}
                                      className={`${
                                        (showResetBtn &&
                                        selectingItemForDelete.index == index &&selectingItemForDelete.cardIndex == cardIndex)
                                          ? "d-flex"
                                          : "d-none"
                                      } btn btn-primary text-white align-items-center justify-content-center p-1 m-1 formBuilder__formBx__items__btn`}
                                    >
                                      <FontAwesomeIcon
                                        size="xs"
                                        color={formMode == "view" ? "gray" : ""}
                                        icon={["fas", "gear"]}
                                      />
                                    </div>
                                    {Obj.typeName != "Card" && (
                                    ////{Obj.typeName != "Step" && (
                                      <div
                                        onMouseMove={(e) => {
                                          e.stopPropagation();
                                          setStateBoxInput("clone");
                                        }}
                                        onMouseLeave={(e) => {
                                          setStateBoxInput(null);
                                        }}
                                        onMouseUp={(e) => {
                                          e.stopPropagation();
                                          return false;
                                        }}
                                        onClick={(p) => {
                                          if (
                                            formMode != "view" &&
                                            inputs[cardIndex][index].SystemKey !=
                                              "Description" &&
                                            inputs[cardIndex][index].SystemKey !=
                                              "RequesterPositionId"
                                          ) {
                                            setInputMode("duplicate");
                                            setEditInput(Obj);
                                            setShowSetting(false);
                                            addNewInput(Obj, index);
                                            
                                          }
                                        }}
                                        className={`${
                                        (showResetBtn &&
                                        selectingItemForDelete.index == index &&selectingItemForDelete.cardIndex == cardIndex)
                                            ? "d-flex"
                                            : "d-none"
                                        } btn btn-warning text-white align-items-center justify-content-center p-1 m-1 formBuilder__formBx__items__btn`}
                                      >
                                        <FontAwesomeIcon
                                          size="xs"
                                          color={formMode == "view" ? "gray" : ""}
                                          icon={["fas", "clone"]}
                                        />
                                      </div>
                                    )}
                                    <div
                                      onMouseMove={(e) => {
                                        e.stopPropagation();
                                        setStateBoxInput("delete");
                                      }}
                                      onMouseLeave={(e) => {
                                        setStateBoxInput(null);
                                      }}
                                      onClick={(p) => {
                                        formMode != "view" &&
                                          inputs[cardIndex]?.inputList[index].SystemKey !=
                                            "Description" &&
                                          inputs[cardIndex]?.inputList[index].SystemKey !=
                                            "RequesterPositionId" &&
                                          removeInput(p, index, "delete" ,cardIndex);
                                      }}
                                      className={`${
                                        (showResetBtn &&
                                        selectingItemForDelete.index == index &&selectingItemForDelete.cardIndex == cardIndex)
                                          ? "d-flex"
                                          : "d-none"
                                      } btn btn-danger text-white  align-items-center justify-content-center  p-1 m-1 formBuilder__formBx__items__btn`}
                                    >
                                      <FontAwesomeIcon
                                        size="xs"
                                        color={formMode == "view" ? "gray" : ""}
                                        icon={["fas", "trash"]}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}            
                          </div>
                          </>
                        ))}
                      </>
                      {/* {
                            inputs.length > 0 && formMode != 'view' &&
                                <div className="col-lg-12 mt-1 btns_form">
                                    <div className="m-1">
                                        <Button btnType="submit" value="Save" onClick={(e)=>{sendData(e)}}/>
                                        <Button btnType="cancel" value="cancel" onClick={()=>{
                                                  Toast(trans("modalclosemessage"),"warning","confirm", ()=>{localStorage.removeItem("formbuilder");sessionStorage.setItem("changingforms" , "false");setCountList({text:0,textArea:0,number:0,date:0,time:0,timeLength:0,selectBox:0,RadioButton:0,checkBox:0,ProgressBar:0,price:0,Message:0,Step:0,Position:0,Person:0,Sex:0});setInformationForm(null);setToolBarType(0);setFormMode('view');setInputs([]);});
                                            }}/> 
                                    </div>
                                </div> 
                            } */}
                    </div>
                  </>
                )
              ) : (
                <Loading />
              )}
            </>
          </div>
        </div>
        {showSetting && (
          <div className="col-2" style={{ padding: "0" }}>
            <div
              className="glassBox border"
              style={{ overflowY: "auto", height: "85vh", overflowX: "hidden" }}
            >
              <InputSetting
                onHide={closeSetting}
                object={editInput}
                handleNewSetting={(e ,newFormul ,newCondition) => {
                  settingChange(e);
                if(newFormul) {setFormula({...formula ,...newFormul })}
                else{
                
                  delete formula?.[editInput?.SystemKey]
                  setFormula(formula)
                }
                  
                if( newCondition) {setCondition({...condition ,...newCondition })}
                else{
                  delete condition?.[editInput?.SystemKey]
                  setCondition(condition)

                }
             
                }}
               condition={condition}
                Formul={formula}

                systemKeys={inputs}  
                filledSystemKey={inputMode}
              />
            </div>
          </div>
        )}
        {dragItem && (
          <div
            className="position-absolute p-2 border border-1 m-1 d-flex justify-content-between align-items-center glassBox"
            style={{
              left: `${positionOnPage[0]}px`,
              top: `${positionOnPage[1] - 50}px`,
              cursor: "move",
              userSelect: "none",
              width: "200px",
            }}
          >
            <div className="showDots">
              {!dragItem.SystemKey ? dragItem.typeName : dragItem.label}
            </div>
            {dragItem?.icon && <FontAwesomeIcon icon={dragItem.icon} />}
          </div>
        )}
      </div>}
    </>
  );
};
